import { PluginKey, Plugin } from "prosemirror-state";
const popupsEnabledPluginKey = new PluginKey("popupsEnabled");
export function popupsEnabledPlugin(popupsSelector) {
    return new Plugin({
        key: popupsEnabledPluginKey,
        state: {
            init: () => false,
            apply: (tr, value) => {
                const update = tr.getMeta(POPUPS_ENABLED_META_KEY);
                if (update !== undefined) {
                    return update;
                }
                return value;
            },
        },
        props: {
            handleDOMEvents: {
                blur: (view, event) => {
                    const relatedTarget = event.relatedTarget;
                    if (!relatedTarget || !relatedTarget.closest(popupsSelector)) {
                        // set to disabled just if `relatedTarget` is not a content within one of editor's popups
                        setPopupsEnabled(view, false);
                    }
                    return false;
                },
                focus: (view) => {
                    setPopupsEnabled(view, true);
                    return false;
                },
            },
        },
    });
}
const POPUPS_ENABLED_META_KEY = "POPUPS_ENABLED_META_KEY";
export function setPopupsEnabled(view, active) {
    view.dispatch(view.state.tr.setMeta(POPUPS_ENABLED_META_KEY, active));
}
export function isPopupsEnabled(state) {
    return popupsEnabledPluginKey.getState(state);
}
